import isArray from 'lodash-es/isArray'

import { DOC_FLOW_RESULT_STATUS_FILTER_LIST } from '../../constants/filter'
import { LABEL_GETTER } from '../../constants/option'
import { isValueStringType } from '../../utils/common'
import { getDocFlowResultStatusFilterOption } from '../../utils/docFlow'
import { getRequestTitle } from '../Request'

import {
  FILTER_REQUEST_PARAM_NAME_PERMANENT_FILTERS,
  FILTER_REQUEST_PARAM_NAME_VALUES,
} from './Filter.constants'

import ProviderIcon from '../../icons/provider.svg'

function getDocFlowResultStatusFilterListItemGetter(name) {
  return option => {
    const { statuses, statusId } = getDocFlowResultStatusFilterOption({
      name,
      value: option.value,
    })

    return { item: option, status: statusId, statuses }
  }
}

export function getFilterSingleFieldUrlParams(params) {
  const newParams = Object.entries(params).reduce(
    (acc, [paramName, paramValue]) => {
      if (paramName === FILTER_REQUEST_PARAM_NAME_VALUES) {
        const valueParams = isArray(paramValue)
          ? paramValue.map(i => ['value', i])
          : [['value', paramValue]]

        return [...acc, ...valueParams]
      }

      if (
        paramName === FILTER_REQUEST_PARAM_NAME_PERMANENT_FILTERS &&
        paramValue.length > 0
      ) {
        return [...acc, ...paramValue]
      }

      if (
        paramName !== FILTER_REQUEST_PARAM_NAME_PERMANENT_FILTERS &&
        paramValue
      ) {
        return [...acc, [paramName, paramValue]]
      }

      return acc
    },
    []
  )

  return new URLSearchParams(newParams)
}

// Descriptors that carry their own option list — facets not resolvable through
// the single-field endpoint. Both shared hosts resolve them locally.
// TODO: remove once every facet is served by the single-field endpoint.
export function getStaticFilterOptionsByName(availableFilters) {
  return Object.fromEntries(
    availableFilters
      .filter(filter => isArray(filter.options))
      .map(filter => [filter.name, filter.options])
  )
}

// Mimics the single-field response shape so hydration keeps one code path.
// TODO: remove together with `getStaticFilterOptionsByName`.
export function getStaticFilterSingleFieldResponse(staticOptions, items) {
  const values = (isArray(items) ? items : [items]).map(String)

  return {
    data: {
      items: staticOptions.filter(option =>
        values.includes(String(option.value))
      ),
    },
  }
}

export function getRequestFilterListItem(option) {
  const requestText = getRequestTitle({
    requestNumber: option.label?.request_no,
    title: option.label?.title,
  })
  const requestDescription = option.label?.building?.address

  return {
    description: requestDescription,
    isArchived: option.label?.archived,
    isMulti: true,
    isPersistent: option.is_persistent,
    text: requestText,
    value: option.value,
  }
}

export function getFilterListItemsByNames({ ListItem, names }) {
  return Object.fromEntries(names.map(name => [name, ListItem]))
}

export function getDocFlowResultStatusFilterListItemPropsGetters() {
  return Object.fromEntries(
    DOC_FLOW_RESULT_STATUS_FILTER_LIST.map(name => [
      name,
      getDocFlowResultStatusFilterListItemGetter(name),
    ])
  )
}

export function getContractorFilterListItem() {
  return {
    Icon: ProviderIcon,
  }
}

/**
 * Returns translated text for a filter option by looking up the per-filter-name
 * rule in `LABEL_GETTER`. Returns `null` when no rule matches so the caller can
 * fall back to its default behavior.
 */
export function getFilterOptionLabel({ entity, name, option, t }) {
  const getter = LABEL_GETTER[name]

  if (!getter) {
    return null
  }

  const { isPersistent, isSystem, label, tObj } = getter(option, entity)

  if (!isValueStringType(label)) {
    return null
  }

  return isPersistent || isSystem ? t(label, tObj) : label
}
